/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const WalletWithMoneyIconOutline = createIcon({
  displayName: 'WalletWithMoneyIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect width="24" height="24" fill="none" />
      <path
        d="M18.5,6.95324l-2.36482-3.1531a2,2,0,0,0-2.7094-.4641L7.92984,7"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M18.5,11.5H21a1,1,0,0,1,1,1v3a1,1,0,0,1-1,1H18.5A2.5,2.5,0,0,1,16,14v0a2.5,2.5,0,0,1,2.5-2.5Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M21,11.5v-2A2.5,2.5,0,0,0,18.5,7H5.5A2.5,2.5,0,0,0,3,9.5v9A2.5,2.5,0,0,0,5.5,21h13A2.5,2.5,0,0,0,21,18.5v-2"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const WalletWithMoneyIconTwoTone = createIcon({
  displayName: 'WalletWithMoneyIconTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect width="24" height="24" fill="none" />
      <Box
        as="path"
        d="M18.5,6.95324l-2.36482-3.1531a2,2,0,0,0-2.7094-.4641L7.92984,7"
        fill="twoToneLightColor"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="path"
        d="M21,11.5v-2A2.5,2.5,0,0,0,18.5,7H5.5A2.5,2.5,0,0,0,3,9.5v9A2.5,2.5,0,0,0,5.5,21h13A2.5,2.5,0,0,0,21,18.5v-2"
        fill="twoToneFillColor"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="path"
        d="M18.5,11.5H21a1,1,0,0,1,1,1v3a1,1,0,0,1-1,1H18.5A2.5,2.5,0,0,1,16,14v0a2.5,2.5,0,0,1,2.5-2.5Z"
        fill="twoToneLightColor"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const WalletWithMoney: FC<CustomIconProps> = (props) => {
  switch (props.variant || 'outline') {
    case 'twoTone':
      return <CustomIcon as={WalletWithMoneyIconTwoTone} {...props} />
    default:
      return <CustomIcon as={WalletWithMoneyIconOutline} {...props} />
  }
}

export default memo(WalletWithMoney)
